module.exports = __webpack_public_path__ + "img/sv46on.819a1a77.svg";